import { gql } from "@apollo/client";

export const GET_TODAY_SHIPPING = gql`
  query GetTodayShipping(
    $take: Float!
    $skip: Float!
    $selectedDate: Timestamp!
  ) {
    getTodayShipping(take: $take, skip: $skip, selectedDate: $selectedDate) {
      carrier
      totalCount
      fileCount
      userGroup {
        shipping {
          shippings {
            order {
              id
              orderReference
              patient {
                firstName
                lastName
              }
            }
          }
          trackingNumber
          id
        }
        displayName
        clinicNumber
      }
    }
    getTodayShippingData {
      carrier
      clinicNumber
      orderCount
      shippingCount
    }
  }
`;

export const GET_TODAY_SHIPPING_BY_DELIVERY_CARRIER = gql`
  query GetTodayShippingByDeliveryCarrier(
    $take: Float!
    $skip: Float!
    $deliveryCarrier: String!
    $selectedDate: Timestamp!
    $filters: ShippingFiltersInput
  ) {
    getTodayShippingByDeliveryCarrier(
      take: $take
      skip: $skip
      deliveryCarrier: $deliveryCarrier
      selectedDate: $selectedDate
      filters: $filters
    ) {
      shipping {
        shippings {
          order {
            id
            orderReference
            patient {
              firstName
              lastName
            }
          }
        }
        trackingNumber
      }
      displayName
      clinicNumber
    }
  }
`;

export const PRINT_CLINIC_LABEL = gql`
  mutation PrintClinicLabel($userGroupId: String!) {
    printClinicLabel(userGroupId: $userGroupId)
  }
`;

export const GET_TODAY_SHIPPING_BY_CLINIC_ID = gql`
  query GetTodayShippingByClinicId($userGroupId: String!) {
    getTodayShippingByClinicId(userGroupId: $userGroupId) {
      id
      trackingNumber
      shippings {
        order {
          orderReference
          patient {
            firstName
            lastName
          }
        }
      }
    }
  }
`;
